import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { ResponseWrapper } from './ResponseWrapper/ResponseWrapper';
import styles from './ResponseWrapper/ResponseWrapper.module.scss';
export const TypingIndicator = () => {
    return (_jsx(ResponseWrapper, { className: styles.typingWrapper, children: _jsxs("div", { className: styles.loaderWrapper, children: [_jsx("div", { className: cn(styles.typingDot, styles.dot1) }), _jsx("div", { className: cn(styles.typingDot, styles.dot2) }), _jsx("div", { className: cn(styles.typingDot, styles.dot3) })] }) }));
};
